import { connect } from 'react-redux';
import partial from 'lodash/partial';
import { toggleViolationModal, reportViolationRequest } from 'project/ducks/project';
import ViolationModal from 'project/components/violation_modal';

const mapStateToProps = ({ project }) => ({
  info: project.projectPage.project.violationInfo
});

export default connect(mapStateToProps, {
  onClose: partial(toggleViolationModal, undefined),
  reportRequest: reportViolationRequest
})(ViolationModal);



// WEBPACK FOOTER //
// ./project/containers/violation_modal.js